import './headerlessons.css';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useDarkMode } from '../DarkModeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faGauge,
  faBookOpen
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, NavLink } from 'react-router-dom';
import { MobileProfileMenu } from '../header/MobileProfileMenu';
import ProfileIcon from '../imagesHome/profile.png';
import ProfileIconWhite from '../imagesHome/profile_white.png';
import CursuriIcon from '../imagesHome/cursuri.png';
import CursuriIconWhite from '../imagesHome/cursuri_white.png';
import MedalIcon from '../imagesHome/medal.png';
import MedalIconWhite from '../imagesHome/medal_white.png';



const HeaderLessons = () => {
  

const { darkMode } = useDarkMode();

  const [isMenuOpen, setIsMenuOpen] = useState(false); // ✅ tot aici, sus
  const [isSoundOn, setIsSoundOn] = useState(true);
  const menuRef = useRef(null);
  const location = useLocation();

  // 🧠 Aici e bine să stea
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);



  return (
   <div className='general-lesson-menu'>
  
    <div className='header-lesson'>

      {/* Logo în stânga */}
      <div className="header-left">
        <NavLink to="/userpage">
          <div className='logoprofile'>
            <img src='/static/media/logo.6813a446cccb806fd043.png' alt="Logo" />
          </div>
        </NavLink>
      </div>

      {/* Meniu în centru */}
      <div className="header-center">
        <nav className="bottom-nav">
          <NavLink to="/userpage" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <div className='menu-on-customize'>
               <img src={darkMode ? ProfileIconWhite : ProfileIcon} className="icon" alt="Profil" />
              <span>Profil</span>
            </div>
          </NavLink>

          <NavLink to="/cursuri" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <div className='menu-on-customize'>
               <img src={darkMode ? CursuriIconWhite : CursuriIcon} className="icon" alt="Cursuri" />

              <span>Cursuri</span>
            </div>
          </NavLink>

          <NavLink to="/clasament" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <div className='menu-on-customize'>
             <img src={darkMode ? MedalIconWhite : MedalIcon} className="icon-clasament" alt="Clasament" />
              <span>Clasament</span>
            </div>
          </NavLink>
        </nav>
      </div>

      {/* Meniu mobil / profil în dreapta */}
      <div className="header-right">
        <MobileProfileMenu />
      </div>

    </div>
    {!(location.pathname === '/userpage' || location.pathname === '/clasament') && (
      <div className='undermenu-line'></div>
    )}
</div>

  );
};

export default HeaderLessons;
